<template>
    <tr :class="printable ? '' : color" style="margin-bottom: 10px important!;"
        v-if="tem_totalizacao">
        <template v-for="(coluna, ic) in relatorio.result.columns">
            <th :key="ic" :class="'text-' + coluna.align" :style="printableFont" v-if="true">
                <span v-if="coluna.treat && coluna.type == 'value'" :style="printableFont" >
                    {{ formatar ( coluna, totalizar (dados, coluna.name, agrupamento, coluna) ) }}
                </span>
                <span v-else-if="!ic">
                    <span :class="'ml-' + ( nivel * 2 )">
                        <span v-if="titulo">
                            {{ titulo }} {{ get_outros_campos() }}
                        </span>
                        <span v-else>
                            SUBTOTAL
                        </span>
                    </span>
                </span>
            </th>
            <th :key="'percent-g-' + ic" v-if="coluna.percent">
                &nbsp;
            </th>
        </template>
    </tr>
</template>

<script>
import _ from 'lodash';
import * as moment from "moment";

export default {
    props: ['tem_totalizacao', 'relatorio', 'printableFont', 'dados', 'nivel', 'agrupamento', 'titulo', 'printable'],

    computed: { 
        color: function () { 
            switch (this.nivel) {
                case 2: return 'table-secondary';
                case 1: return 'table-info';
                default: return 'table-primary';
            }
        }
    },

    methods: { 
        formatar(campo, valor) {
            if (!campo.format && campo.type != "value") 
                return valor;

            switch (campo.type) {
                case "time":
                case "timestamp":
                    return valor 
                        ? ( campo.format.substr(0,3) == 'H:i' 
                        ? valor.substr(11,5)
                        : ( this.$util.getFormatDate(valor) + ( campo.format.substr(0,9) == 'd/m/Y H:i' ? ( ' ' + valor.substr(11,5) ) : '' ) ) )
                        : "";

                case "value":
                    if ( !isNaN(valor) && campo.format == 'min2time' ) { 
                        return moment.utc(valor * 60 * 1000).format("HH:mm:ss");
                    }

                    if ( isNaN(valor) || isNaN(campo.format) ) { 
                        return valor;
                    }

                    return this.$util.formatNumber(valor, campo.format);

                default:
                return valor;
            }
        },

        totalizar(dados, campo, flat = 0, info_coluna = null) {
            if (flat) {
                if ( flat == 3 ) { 
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.values(dados).flat();
                } else  if ( flat == 2 ) { 
                    dados = _.flatMap(dados, (item) => _.values(item));
                    dados = _.values(dados).flat();
                } else { 
                    dados = _.flatMap(dados);
                }
            }

            let total = dados.reduce((total, item) => {
                return total + ( ( isNaN(item[campo]) || !item[campo] ) ? 0 : parseFloat(item[campo]) );
            }, 0);

            if ( info_coluna && info_coluna.avg && dados.length ) { 
                total = total / dados.length;
            }

            return total;
        },

        get_outros_campos() { 
            let secs = _.get(this.relatorio, 'result.group_cols.' + this.nivel + '.sec', []); 
            if ( secs ) { 

                let dados = _.cloneDeep(this.dados);
                let cont = 0; 

                do {
                    if ( _.get(dados, '0') ) { 
                        break;
                    }
                        
                    dados = _.first(_.values(dados));

                    cont ++;
                } while ( cont < 10 );

                return _.reduce(secs, (acc, sec) => { 
                    const dado = _.get(dados, '0.' + _.get(sec, 'name'), '');
                    return acc + ' / ' + dado;
                }, '');

            }
        },
    }
}
</script>